import {
  DEFAULT_CHECKOUT_PLAN_ID,
  isResumablePlanId,
  isSelectablePlanId
} from "./subscriptionPlans";

/* wiswiz #217: the plan the checkout shows. The URL wins whenever its plan_id changes to a valid plan, whatever the
   current state is. A plan picked in the page (state set before router.push lands) stays while the URL still names
   the previous plan, so a pending URL never reverts a fresh click. The old rule reset only the default plan, which
   turned "yearly, back arrow, monthly" on /abonnement into a yearly dialog for a monthly order. A state that is not
   a valid plan (a resumable plan outside the resume flow) falls back to the URL plan or the default. */
export function syncedCheckoutPlanId({
  selectedPlanId,
  urlPlanId,
  previousUrlPlanId,
  isResumeFlow
}: {
  selectedPlanId: string;
  urlPlanId: string | null;
  previousUrlPlanId: string | null;
  isResumeFlow: boolean;
}): string {
  const validUrlPlanId = isSelectablePlanId(urlPlanId) ? urlPlanId : null;
  const validPreviousUrlPlanId = isSelectablePlanId(previousUrlPlanId) ? previousUrlPlanId : null;
  if (validUrlPlanId !== null && validUrlPlanId !== validPreviousUrlPlanId) return validUrlPlanId;
  const canKeepSelectedPlan =
    isSelectablePlanId(selectedPlanId) || (isResumeFlow && isResumablePlanId(selectedPlanId));
  return canKeepSelectedPlan ? selectedPlanId : (validUrlPlanId ?? DEFAULT_CHECKOUT_PLAN_ID);
}
